import { Update } from '@ngrx/entity';
import { Action } from '@ngrx/store';
import { CompanyEntity } from './company.model';

/* eslint-disable @typescript-eslint/no-shadow */
export enum CompanyActionTypes {
  LoadCompanys = '[Company] Load Companys',
  AddCompany = '[Company] Add Company',
  UpsertCompany = '[Company] Upsert Company',
  AddCompanys = '[Company] Add Companys',
  UpsertCompanys = '[Company] Upsert Companys',
  UpdateCompany = '[Company] Update Company',
  UpdateCompanys = '[Company] Update Companys',
  DeleteCompany = '[Company] Delete Company',
  DeleteCompanys = '[Company] Delete Companys',
  ClearCompanys = '[Company] Clear Companys',
}
/* eslint-enable @typescript-eslint/no-shadow */

export class LoadCompanys implements Action {
  public readonly type = CompanyActionTypes.LoadCompanys;

  constructor(public payload: { companys: CompanyEntity[] }) {}
}

export class AddCompany implements Action {
  public readonly type = CompanyActionTypes.AddCompany;

  constructor(public payload: { company: CompanyEntity }) {}
}

export class UpsertCompany implements Action {
  public readonly type = CompanyActionTypes.UpsertCompany;

  constructor(public payload: { company: CompanyEntity }) {}
}

export class AddCompanys implements Action {
  public readonly type = CompanyActionTypes.AddCompanys;

  constructor(public payload: { companys: CompanyEntity[] }) {}
}

export class UpsertCompanys implements Action {
  public readonly type = CompanyActionTypes.UpsertCompanys;

  constructor(public payload: { companys: CompanyEntity[] }) {}
}

export class UpdateCompany implements Action {
  public readonly type = CompanyActionTypes.UpdateCompany;

  constructor(public payload: { company: Update<CompanyEntity> }) {}
}

export class UpdateCompanys implements Action {
  public readonly type = CompanyActionTypes.UpdateCompanys;

  constructor(public payload: { companys: Update<CompanyEntity>[] }) {}
}

export class DeleteCompany implements Action {
  public readonly type = CompanyActionTypes.DeleteCompany;

  constructor(public payload: { id: string }) {}
}

export class DeleteCompanys implements Action {
  public readonly type = CompanyActionTypes.DeleteCompanys;

  constructor(public payload: { ids: string[] }) {}
}

export class ClearCompanys implements Action {
  public readonly type = CompanyActionTypes.ClearCompanys;
}

export type CompanyActions =
  | LoadCompanys
  | AddCompany
  | UpsertCompany
  | AddCompanys
  | UpsertCompanys
  | UpdateCompany
  | UpdateCompanys
  | DeleteCompany
  | DeleteCompanys
  | ClearCompanys;
